export const COLOUR_DONE_REQUEST = "COLOUR_DONE_REQUEST";
export const COLOUR_DONE_SUCCESS = "COLOUR_DONE_SUCCESS";
export const COLOUR_DONE_FAILED = "COLOUR_DONE_FAILED";